import * as React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import * as _ from 'lodash';

import {
  ticketContactDataSelector,
  ticketLastActivityPreviewSelector,
  ticketLastActivitySelector,
} from '@/redux/app/selectors/ticket';
import { EventElementType } from '@/constants/event-element-type.enum';
import CallInSvg from ':assets/images/call_in.svg';
import CallOutSvg from ':assets/images/call_out.svg';

import { ContactTag } from '../../tag/ContactTag';

const PREVIEW_LINES = 3;
const PREVIEW_SYMBOLS_PER_LINE = 13;
const isLongPreview = (text: string) => {
  let currentLine = 0;
  let rem = PREVIEW_SYMBOLS_PER_LINE;
  for (const token of text.split(/(\s)/)) {
    let len = token.length;
    rem -= len;
    while (rem < 0) {
      currentLine += 1;
      rem = PREVIEW_SYMBOLS_PER_LINE - len;
      len -= PREVIEW_SYMBOLS_PER_LINE;
    }
    if (currentLine >= PREVIEW_LINES) return true;
  }
  return false;
};

export const TicketCardLeft = React.memo(({ ticket }: { ticket: string }) => {
  const lastActivity = useSelector(_.partial(ticketLastActivitySelector, ticket));
  const message = useSelector(_.partial(ticketLastActivityPreviewSelector, ticket)) ?? '';
  const contactData = useSelector(_.partial(ticketContactDataSelector, ticket));
  const tags = contactData?.external_tags;

  let sender = '';
  let prefix = '';
  let prefixElement = null;
  if ([EventElementType.SMS, EventElementType.MMS].includes(lastActivity?.element_type)) {
    if (lastActivity?.element_data?.direction === 'in') {
      sender = contactData?.human_name && contactData?.first_name;
      sender ||= contactData?.display_name ?? lastActivity?.element_data?.sender_name;
    } else {
      sender = lastActivity?.element_data?.sender?.first_name
        ?? lastActivity?.element_data?.sender_name
        ?? lastActivity?.element_data?.sender_type;
    }
    prefix = `${sender.trim()}: `;
    prefixElement = <span className="sender">{prefix}</span>;
  } else if (lastActivity?.element_type === EventElementType.CALL) {
    if (lastActivity?.element_data?.direction === 'out') {
      prefix = 'Outgoing: ';
      prefixElement = <img className="icon-call-out" src={CallOutSvg} alt={prefix} />;
    } else {
      prefix = 'Inbound: ';
      prefixElement = <img className="icon-call-in" src={CallInSvg} alt={prefix} />;
    }
  }

  return (
    <div className={classNames('ticket-left', isLongPreview(prefix + message) && 'ticket-left-long-preview')}>
      <span className="activity">
        {prefixElement}
        {` ${message}`}
      </span>
      <div className="tags-container">
        <div className="tags">
          {tags instanceof Array && (
            tags.filter(({ name }) => !!name)
              .map(({ name, color }) => (
                <ContactTag
                  search="tickets"
                  searchExact={false}
                  key={name}
                  name={name}
                  color={color}
                  external
                />
              ))
          )}
          <span className="tags-end-filler" />
        </div>
      </div>
    </div>
  );
});
